import { Component, Prop, Event, EventEmitter, h } from '@stencil/core';
import { Color } from '../../interface';
import { DoorState, SlidingDoorState } from './sliding-door-interface';

@Component({
  tag: 'sliding-door-content',
  styleUrl: 'sliding-door.scss',
  shadow: false,
  scoped: true
})
export class RadioButtonContent {
   @Prop() color?: Color;
   @Prop() doorState: string;
   @Prop() stopEnabled: boolean;
   @Prop() loading?: boolean;
   @Event() sendcommand!: EventEmitter<string>;

   render() {
    return (
      <lar-button-group>
          <lar-button
            disabled={this.loading || this.doorState === DoorState.OPEN || this.doorState === DoorState.OPENING || this.doorState === DoorState.CLOSING}
            color={this.color}
            onClick={() => this.sendcommand.emit('open')}
          >
            <lar-translate t="slidingDoor.open" />
          </lar-button>
          <lar-button
            disabled={this.loading || this.doorState === DoorState.CLOSED || this.doorState === DoorState.OPENING || this.doorState === DoorState.CLOSING}
            color={this.color}
            onClick={() => this.sendcommand.emit('close')}
          >
            <lar-translate t="slidingDoor.close" />
          </lar-button>
          {
            this.stopEnabled === true ?
            <lar-button
              disabled={this.loading || (this.doorState !== DoorState.OPENING && this.doorState !== DoorState.CLOSING)}
              color={this.color}
              onClick={() => this.sendcommand.emit('stop')}
            >
              <lar-translate t="slidingDoor.stop" />
            </lar-button> : null
          }
        </lar-button-group>
    );

  }
}